module.exports = __webpack_public_path__ + "img/ChecklistAnimation_NewSplint.6926ebb1.gif";